import { useCallback, useEffect, useState } from 'react';

export const minimumFontSize = 80;
export const maximumFontSize = 130;

export function useChatFontSize(layout: 'phone' | 'tablet') {
  const storageKey = `fanbird.${layout}.font-size`;
  const readSize = useCallback(() => {
    try {
      const saved = Number(localStorage.getItem(storageKey));
      return Number.isInteger(saved) && saved >= minimumFontSize && saved <= maximumFontSize && saved % 10 === 0 ? saved : 100;
    } catch { return 100; }
  }, [storageKey]);
  const [fontSize, setFontSize] = useState(readSize);
  useEffect(() => { setFontSize(readSize()); }, [readSize]);
  const changeFontSize = (delta: number) => {
    const next = Math.max(minimumFontSize, Math.min(maximumFontSize, fontSize + delta));
    setFontSize(next);
    try { localStorage.setItem(storageKey, String(next)); } catch { /* Keep the current selection if storage is unavailable. */ }
  };
  return { fontSize, changeFontSize };
}

export function useTabletFontSize() {
  return useChatFontSize('tablet');
}
